import React from 'react'
import styled from '@emotion/styled'
import { mediaQueriesByDevice } from 'parameters/index'
import DebtConsolidationCalculator, { CalculatorWrapper } from 'experiences/Calculators/DebtConsolidation'
import { Container } from 'components/layout'

export const DebtConsolidationTile = (): JSX.Element => (
	<Container>
		<DebtConsolidationWrapper>
			<LeftColumn>
				<DebtConsolidationCalculator />
			</LeftColumn>
			<RightColumn>
				<h2>Find out how much you could save</h2>
				<StyledP>Not sure if you need a loan? Estimate your savings with our debt consolidation calculator.</StyledP>
				<StyledP>
					Enter your current outstanding debt, interest and remaining term, and we’ll see how much our network of top
					lenders can save you!
				</StyledP>
			</RightColumn>
		</DebtConsolidationWrapper>
	</Container>
)

const DebtConsolidationWrapper = styled.div`
	display: flex;
	justify-content: space-between;

	${mediaQueriesByDevice.tablet} {
		flex-direction: column-reverse;
		padding-top: 0px;
	}
`

const LeftColumn = styled.div`
	width: 60%;
	max-width: 635px;
	box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
	border-radius: 8px;

	${mediaQueriesByDevice.tablet} {
		width: 100%;
		max-width: unset;
		box-shadow: unset;

		${CalculatorWrapper} {
			padding: 24px 0;
		}
	}
`

const RightColumn = styled.div`
	width: 40%;
	padding: 0 0 0 24px;

	${mediaQueriesByDevice.tablet} {
		width: 100%;
		padding: 0;
		margin-bottom: 24px;
	}
`

const StyledP = styled.p`
	margin-top: 32px;
`
